export const phonebook = (baseUrl: string): string => `${baseUrl}/profile/general/phonebook`;
export const checkPhone = (baseUrl: string): string => `${baseUrl}/profile/general/checkphone`;
